import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, makeStyles, useMediaQuery, useTheme, Drawer, Grid, Hidden, Typography, Button, Tooltip } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import logo from './../../../assets/images/logo-new.svg';
import userpic from './../../../assets/images/users/maskot-head.png';
import { drawerWidth } from './../../../store/constant';
import 'react-pro-sidebar/dist/css/styles.css';
import logo_common from './../../../assets/images/new-common-logo.png';
import axios from 'axios';
import CryptoJS from 'crypto-js';

import MenuIcon from '@material-ui/icons/Menu';

const useStyles = makeStyles((theme) => ({
    drawer: {
        [theme.breakpoints.up('md')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    toolbar: theme.mixins.toolbar,
    logoContainer: { background: '#DC9018' }
    , drawerPaper: {
        width: drawerWidth,
        background: theme.palette.common.black,
        color: theme.palette.text.primary,
    },
    drawerPaperLight: {
        width: drawerWidth,
        borderRight: 'none',
        boxShadow: '0 0.15rem 1.75rem 0 rgba(33, 40, 50, 0.15)',
        top: '64px',
        [theme.breakpoints.down('sm')]: {
            top: 0,
        },
    },
    menuCaption: {
        ...theme.typography.menuCaption,
    },
    ScrollHeight: {
        height: 'calc(100vh - 65px)',
        padding: '10px',
    },
    name: {
        fontSize: '18px',
        marginTop: '15px',
        textAlign: 'center',
        fontWeight: '600',
        width: '100%'
    },
}));


const MainLayout = (props) => {

    const handleClick = () => {
        // Call drawerToggle function when the button is clicked
        drawerToggle();

        // You can also pass the function to the onClose prop if needed
        // onClose={drawerToggle}
    };


    const { drawerOpen, drawerToggle, window } = props;
    const classes = useStyles();
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const concustomization = useSelector((state) => state.customization);
    const [partner_name] = React.useState(props.name.split(",")[0]);
    const [file_path] = React.useState(props.name.split(",")[2]);
    const [user_image] = React.useState(props.name.split(",")[3]);
    const [user_menu_hide, set_user_menu_hide] = React.useState(true);

    const [PartnerData, setPartnerData] = useState([]);
    const [partnerID, setpartnerID] = useState(0);
    const [partnerRoleID, setpartnerRoleID] = useState(0);
    const [samecomp, setsamecomp] = useState(0);
    const [affiliate, setaffiliate] = useState("All");
    const [sellonline, setsellonline] = useState("");
    const [voucherdeposit, setvoucherdeposit] = useState("");
    const [partner_profile, setPartner_profile] = useState("");



    const [dropdown, set_dropdown] = React.useState(true);
    const clickDropdown = () => {
        if (dropdown === true)
            set_dropdown(false);
        else
            set_dropdown(true);
    }

    const [MenuName, setMenuName] = useState("");



    const handleLoad = () => {
        const headers = {
            'Content-Type': 'application/json',
            'bcbqtoken': process.env.REACT_APP_SECRET_TOKEN,
            'accesstoken': 'Bearer ' + localStorage.getItem("partner_accesstoken"),
        }
        axios.get(process.env.REACT_APP_API_URL + 'partner/v1/viewsubpartner/' + localStorage.getItem("partner_id"), {
            headers: headers
        })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    var bytes = CryptoJS.AES.decrypt(res.data, process.env.REACT_APP_JWT_PARTNER_SEC);
                    var originalText = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                    setPartnerData(originalText);
                    setpartnerID(parseInt(localStorage.getItem("partner_id")));
                    setpartnerRoleID(originalText.roleid)
                    setsamecomp(originalText.same_acc_id)
                    setaffiliate(originalText.affiliate);
                    setsellonline(originalText.sell_online)
                    setvoucherdeposit(originalText.voucher_deopsit)
                    setPartner_profile(originalText.profile_type);
                    // setModuleIDs(originalText.module_ids);
                    // localStorage.setItem("moduleIDs", originalText.module_ids);
                } else {
                    console.log(res.message);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    useEffect(() => {
        handleLoad();
        if (localStorage.getItem("user_menu_hide") === 'true') {
            set_user_menu_hide(false);
        }
    }, []);


    const drawer = (
        <React.Fragment>
            <Hidden mdUp>
                <Grid container direction="row" justify="center" elevation={5} alignItems="center" spacing={0} className={[classes.toolbar, classes.logoContainer].join(' ')} >
                    <Grid item>
                        {/* <img alt="Logo" src={logo} width={55} /> */}
                        <Tooltip arrow title='This is Beta, please consider put big amount, we are testing this website, in some hack or any case, your funds can be lost.'>
                            <Box mt={0.5}>
                                <img src={logo_common} alt="Logo" width={110} />
                                <MenuIcon className='menu-mobie' onClick={handleClick} />
                            </Box>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Hidden>
            {concustomization.navType === "light" ?
                <PerfectScrollbar className={classes.ScrollHeight} style={{ background: '#CCCCCC' }}>

                    <Grid className="userbox" style={{ background: '#fff', boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)' }}>
                        {user_image !== "" && user_image !== 'null' ?
                            <img alt="Logo" src={process.env.REACT_APP_API_URL + file_path + user_image} width={55} height={55} />
                            :
                            <img alt="Logo" src={userpic} width={55} />
                        }
                        {/* <Typography component={Button} onClick={clickDropdown} className={classes.name}>My user profile </Typography> */}
                        <Typography className={classes.name}>Hello, {partner_name}</Typography>
                    </Grid>

                    {user_menu_hide ?
                        <Grid className="NewCstm_menu light-mode">
                            <div className="contenedor-menu">
                                <ul className="menu">
                                    {(partnerRoleID === 1 && sellonline == "true" ) ?
                                        <li className={MenuName === 'dashboard' ? 'active dashboard' : 'dashboard'} onClick={(event) => setMenuName("dashboard")}><Link to="/Dashboard_new">Dashboard</Link></li>
                                        :
                                        <li className={MenuName === 'dashboard' ? 'active dashboard' : 'dashboard'} onClick={(event) => setMenuName("dashboard")}><Link to="/Dashboard_voucher">Dashboard</Link></li>
                                    }
                                    {/* <li className={MenuName === 'transactions' ? 'active transactions' : 'transactions'} onClick={(event) => setMenuName("transactions")}><Link to="/Transactions">Transactions</Link></li> */}
                                    {(partnerRoleID === 1 && sellonline== "true") ?
                                        <li className={MenuName === 'transactions' ? 'active transactions submenu' : 'transactions submenu'} onClick={(event) => setMenuName("transactions")}><Link href="#">Affiliate</Link>
                                            <ul>
                                                <li><Link to="/Withdrawal_Transactions">Withdrawal Transactions</Link></li>
                                                <li><Link to="/Deposit_Transactions">Deposit Transactions</Link></li>
                                                <li><Link to="/Withdrawal_Invoices">Billing</Link></li>
                                            </ul>
                                        </li>
                                        : ''}

                                    {(voucherdeposit=="true") ?
                                        <li className={MenuName === 'voucher' ? 'active transactions submenu' : 'transactions submenu'} onClick={(event) => setMenuName("voucher")}><Link href="#">Voucher</Link>
                                            <ul>
                                                {(partnerRoleID === 1 && partner_profile=="Corporate") ?
                                                    <li><Link to="/SellerList">Accounts</Link></li>
                                                    : (partnerRoleID === 2) ?
                                                        <li><Link to="/SellersUsersList">Accounts</Link></li>
                                                        : ''
                                                }
                                                <li><Link to="/PrepaidCardList">Voucher Card</Link></li>
                                                {(partnerRoleID === 1 || partnerRoleID === 2 && samecomp== 0) ?
                                                    <li><Link to="/Profit_Invoice">Billing</Link></li>
                                                :
                                                ""
                                                }
                                                {(partnerRoleID === 1 || partnerRoleID === 2) ?
                                                 <li><Link to="/Settlement">Settlement</Link></li>
                                                 :
                                                 ""
                                                }
                                            </ul>
                                        </li>
                                        : ''}

                                    <li className={MenuName === 'administrator' ? 'active administrator submenu' : 'administrator submenu'} onClick={(event) => setMenuName("administrator")}><Link href="#">My Profile</Link>
                                        <ul>
                                            <li><Link to="/Editprofile">Edit Profile</Link></li>
                                            <li><Link to="/Change_Password">Change Password</Link></li>
                                            {/* <li><Link to="/Bank_Details">Bank Details Management</Link></li> */}
                                            <li><Link to="/TwoSecurity">2FA</Link></li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </Grid>
                        : ''}

                </PerfectScrollbar>

                :
                <PerfectScrollbar className={classes.ScrollHeight} style={{ background: '#272727' }}>

                    <Grid className="userbox" style={{ background: '#000', boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)' }}>
                        {user_image !== "" && user_image !== 'null' ?
                            <img alt="Logo" src={process.env.REACT_APP_API_URL + file_path + user_image} width={55} height={55} />
                            :
                            <img alt="Logo" src={userpic} width={55} />
                        }
                        {/* <Typography component={Button} onClick={clickDropdown} className={classes.name}>My user profile</Typography> */}
                        <Typography className={classes.name}>Hello, {partner_name}</Typography>
                    </Grid>

                    {user_menu_hide ?
                        <Grid className="NewCstm_menu dark-mode">
                            <div className="contenedor-menu">
                                <ul className="menu">
                                (partnerRoleID === 1 && sellonline == "true" ) ?
                                        <li className={MenuName === 'dashboard' ? 'active dashboard' : 'dashboard'} onClick={(event) => setMenuName("dashboard")}><Link to="/Dashboard_new">Dashboard</Link></li>
                                        :
                                        <li className={MenuName === 'dashboard' ? 'active dashboard' : 'dashboard'} onClick={(event) => setMenuName("dashboard")}><Link to="/Dashboard_voucher">Dashboard</Link></li>
                                    }

                                    {(partnerRoleID === 1 && sellonline=="true") ?
                                        <li className={MenuName === 'transactions' ? 'active transactions submenu' : 'transactions submenu'} onClick={(event) => setMenuName("transactions")}><Link href="#">Affiliate</Link>
                                            <ul>
                                                <li><Link to="/Withdrawal_Transactions">Withdrawal Transactions</Link></li>
                                                <li><Link to="/Deposit_Transactions">Deposit Transactions</Link></li>
                                                <li><Link to="/Withdrawal_Invoices">Billing</Link></li>
                                            </ul>
                                        </li>
                                        : ''}

                                        {(voucherdeposit=="true") ?
                                        <li className={MenuName === 'voucher' ? 'active transactions submenu' : 'transactions submenu'} onClick={(event) => setMenuName("voucher")}><Link href="#">Voucher</Link>
                                            <ul>
                                                {(partnerRoleID === 1 && partner_profile=="Corporate") ?
                                                    <li><Link to="/SellerList">Accounts</Link></li>
                                                    : (partnerRoleID === 2) ?
                                                        <li><Link to="/SellersUsersList">Accounts</Link></li>
                                                        : ''
                                                }
                                                <li><Link to="/PrepaidCardList">Voucher Card</Link></li>
                                                {(partnerRoleID === 1 || partnerRoleID === 2 && samecomp== 0) ?
                                                    <li><Link to="/Profit_Invoice">Billing</Link></li>
                                                :
                                                ""
                                                }
                                                {(partnerRoleID === 1 || partnerRoleID === 2) ?
                                                 <li><Link to="/Settlement">Settlement</Link></li>
                                                 :
                                                 ""
                                                }
                                            </ul>
                                        </li>
                                        : ''}

                                        <li className={MenuName === 'administrator' ? 'active administrator submenu' : 'administrator submenu'} onClick={(event) => setMenuName("administrator")}><Link href="#">My Profile</Link>
                                        <ul>
                                            <li><Link to="/Editprofile">Edit Profile</Link></li>
                                            <li><Link to="/Change_Password">Change Password</Link></li>
                                            {/* <li><Link to="/Bank_Details">Bank Details Management</Link></li> */}
                                            <li><Link to="/TwoSecurity">2FA</Link></li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </Grid>
                        : ''}

                </PerfectScrollbar>
            }


        </React.Fragment>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <nav className={classes.drawer} aria-label="mailbox folders">

            <Drawer
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={drawerToggle}
                classes={{ paper: classes.drawerPaperLight }}
                ModalProps={{ keepMounted: true }}
            >
                {drawer}
            </Drawer>
        </nav>
    );
};

export default MainLayout;
